// controller.ts

export enum ControllerType {
  PLAYSTATION = "PlayStation 5",
  XBOX_SERIES = "Xbox Series S|X",
  POOL_STICK = "Pool Stick",
}

export enum ControllerCondition {
  DAMAGED = "DAMAGED",
  POOR = "POOR",
  PLAYABLE = "PLAYABLE",
  GOOD = "GOOD",
  EXCELLENT = "EXCELLENT",
}

export enum ControllerStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export type Controller = {
  registrationDate: Date;
  nickname: String;
  controllerType: ControllerType;
  barcodeId: String;
  controllerCondition: ControllerCondition;
  id?: string;
};
